import React from "react"
import Styles from "../layouts/styles/_vars.scss"

import FEATURE_FLAGS from "./flags"

import { PAGE_NAMES } from "./urls"

const uselog = () => {
  try {
    return !!JSON.parse(window.sessionStorage.getItem("exo-debug"))
  } catch (e) {
    return false
  }
}

/// imported from SASS
/// so i guess it turns out these are added to Styles on any page...
/// @see below as well
const BREAKPOINTS = {
  MOBILE: Styles.breakpointPhone, // 768
  MOBILE_ANY: Styles.breakpointMobile,
  DESKTOP: Styles.breakpointAvgDesk
}

const COLORS = {
  FLURO: "fluro",
  WORKS: "works",
  ALERT: "alert",
  WORKS_TO_PINK: "works_to_pink",
  WORKS_TO_LIGHTBLUE: "works_to_lightblue",
  PINK_TO_WORKS: "pink_to_works",
  BLUE: "blue",
  WHITE: "white",
  BLACK: "black",
  DARK: "charcoal",
  INKY: "inky",
  TIN: "tin",
  MIDSOMMAR: "midsommar"
}

const GRADIENTS = {
  PURPLE_BLUE: "purpleBlue",
  PURPLE_PINK: "purplePink",
  BLUE_FLURO: "blueFluro",
  FLURO_BLUE: "fluroBlue"
}

const CONTENT_TYPES = {
  COPY: "ContentfulCopy",
  QUOTE: "ContentfulQuote",
  IMAGE: "ContentfulImage",
  SPOTLIGHT: "ContentfulProductSpotlight",
  VIDEO: "ContentfulVideo",
  DROPDOWN: "ContentfulDropdownCopy",
  AUDIO: "ContentfulAudio",
  FORM: "ContentfulForm",
  TITLE: "ContentfulTitle",
  SUBTITLE: "ContentfulSubTitle"
}

// group content types against properties, such as being "Wide"
const CONTENT_PROPERTIES = {
  WIDE: [CONTENT_TYPES.SPOTLIGHT, CONTENT_TYPES.VIDEO]
}

const EVENTS = {
  KEYEVENT: "keydown",
  RESIZE: "resize",
  CLICK: "click",
  KEYS: {
    ARROWS: {
      UP: ["ArrowUp", "Up", 38],
      RIGHT: ["ArrowRight", "Right", 39],
      DOWN: ["ArrowDown", "Down", 40],
      LEFT: ["ArrowLeft", "Left", 37]
    },
    ESC: ["Escape", "Esc", 27],
    TAB: ["Tab"],
    SPACE: [" ", "Spacebar", 32],
    ENTER: ["Enter", 13],
    UNKNOWN: [229]
  }
}

/// these could be Contentful driven one day
const HERO_TYPES = {
  NARROWHOME: "narrowhome",
  NARROW: "narrow",
  WIDE: "wide",
  GRID: "grid"
}

// Appearance settings for Article content Images
const IMAGE_DISPLAY = {
  FIXED: "Fixed",
  FLUID: "Fluid"
}

/// so i guess it turns out these are added to Styles on any page...
/// @see above as well
const MEDIA_QUERIES = {
  AVG_DESKTOP: Styles.mediaAvgDesktop
}

const MISC = {
  LOGO_CLASS: "site-logo",
  // see analytics.js for more metrics constants
  ANALYTICS: {
    CONTACT_SUCCESS: "metricsContactSuccess",
    SUBSCRIBE_SUCCES: "metricsSubscribeSuccess",
    SUBSCRIBE_FAIL: "metricsSubscribeFail"
  },
  EXO_TEXT_ANIMATE: true
}

const NEWS = {
  MIN_SWIPE: 100,
  MAX_TITLE_LENGTH: 42,
  MAX_TITLE_LENGTH_MOBILE: 58
}

const FLAGS = FEATURE_FLAGS

// only log if session storage key exists
const LOG = uselog()

const SETTINGS = {
  KEYS: {
    // eslint-disable-next-line no-eval, no-undef
    API_CAPTCHA: GOOGLE_V2_RECAPTCHA
  },
  EXTERNAL: {
    API_CAPTCHA_URL: "https://www.google.com/recaptcha/api.js"
  }
}

const SUBMIT = {
  IDLE: 0, // as index 0 for below
  BUSY: 100,
  SUCCESS: 1,
  FAIL: -1,
  CAPTED: -2
}

const SUBMIT_PROGRESS = [SUBMIT.FAIL, SUBMIT.IDLE, SUBMIT.BUSY, SUBMIT.SUCCESS]

// ***SOME*** of these come from the CMS
const THEMES = {
  DARK: "dark",
  SLATE: "slate",
  LIGHT: "light",
  TIN: "tin",
  BLACK: "black"
}

const PAGE_TRACKER_KEYS = {
  BLOG: "blog",
  NEWS: "news",
  PRESS_RELEASE: "press release",
  MEDIA_COVERAGE: "media coverage",
  LEADERSHIP_PEOPLE: "leadership people",
  CAREERS: "careers",
  INVESTORS: "investors",
  CUSTOMER_SUPPORT: "customer support",
  PRODUCT_PAGES: "product pages",
  TECHNOLOGY_PAGE: "technology page",
  VISION_PAGE: "vision page",
  RESOURCES_PAGE: "resources pages",
  WEBINAR_LP: "webinar LPs",
  WEBINAR_READING_PAGES: "webinar reading pages",
  WEBINAR_RECORDING_PAGES: "webinar recording pages",
  CONTACT_US: "contact us",
  BOOK_A_DEMO: "book a demo",
  CASE_STUDIES: "case studies",
  CAMPAIGN_LP: "campaign LPs",
  NEWROOM_HOMEPAGE: "newsroom homepage",
  RESOURCES_HOMEPAGE: "resources homepage",
  PODCASTS: "podcasts",
  GUIDES: "guides",
  EVENTS: "events",
  HOMEPAGE: "homepage"
}

const PAGE_TRACKER_VALUES = {
  // Hubspot content type
  LANDING_PAGE: "landing-page",
  BLOG_POST: "blog-post",
  WEBSITE_PAGE: "standard-page",
  KNOWLEDGE_ARTICLE: "knowledge-article",
  LISTING_PAGE: "listing-page"
}

const JOBS = [
  {
    pathname: "job-post",
    buttonName: "Senior Cloud Software Engineer",
    header: "Career",
    title: "Senior Cloud Software Engineer",
    description: (
      <>
        Design, develop, and implement cloud-based software applications for the company’s
        proprietary medical imaging services platform. Architect, design, and deploy full-stack
        software products using Cloud backend software systems. Work closely with the Product
        Management and clinical teams to break down market requirements into defined system and
        subsystem requirements. Prototype and iterate ideas to share with stakeholders and develop
        detailed cloud infrastructure designs and architecture by preparing data models, flow
        charts, schematic diagrams, and mappings of data sources, transformations, and data
        movement. Oversee all the stages of the Software Development Life Cycle, including coding
        standards, code reviews, source control management, continuous integration, build processes,
        testing, and operations. Build scalable and versatile applications for medical device users
        and configure RESTFUL app frameworks to allow customers to interact with the Cloud interface
        and medical devices. Customize and enhance cloud and hybrid-cloud software to improve
        performance and strengthen the integration capabilities of current and future modifications.
        Monitor, troubleshoot, and identify performance, connectivity, and other issues for the
        applications hosted in the Azure platform. Ensure that the development team follows the
        Design Control Process, and that the software meets all Quality Management System (QMS)
        requirements. Manage project and engineering schedules and deliverables and prepare project
        status reports for management as needed. Stay abreast of the latest technological advances
        and industry trends to ensure optimal performance and effective cloud software development.
      </>
    ),
    requirements: (
      <>
        This position requires a Master’s degree in Computer Science, Computer Engineering, or a
        related field and two years of experience in the job offered or a related field. This may be
        substituted with a Bachelor’s degree in Computer Science Computer Engineering, or a related
        field and five years of experience in the job offered or a related position. The position
        requires skills and knowledge in AWS, SQL, RESTFul, SAAS Solutions, and Fullstat software
        product development.
        <br />
        Salary: $160,314.00 to $178,041.00 per year
        <br />
        40 hours/week.
        <br />
        Job Site: Santa Clara, CA.
        <br />
        Email Resume to: Exo Imaging, Inc. at{" "}
        <a
          href="mailto:HR@exo.inc?subject = Career - Director of Software Applications Engineering:"
          alt="Submit your resume here"
        >
          HR@exo.inc
        </a>
      </>
    )
  },
  {
    pathname: "job-post2",
    buttonName: "Senior Test Engineer",
    header: "Career",
    title: "Senior Test Engineer",
    description: (
      <>
        Design, develop and implement testing systems for the company’s proprietary medical devices
        during each phase of the development life cycle. Conduct cross-functional reviews of the
        hardware and software in a regulated environment and develop quality assurance and
        performance tests to ensure the efficiency and optimization of products. Design, develop,
        and implement test plans and objectives for products including testing strategy, schedule,
        test scenarios, data preparations, and test execution. Perform validation, quality
        assurance, and performance testing during each phase of the product life cycle using testing
        methods such as OQ, IQ, PQ, Gage R&amp;R, process capability, and TMV. Implement changes in
        the testing conditions and environments and measure the impact through the various
        performance indicators. Identify deficiencies and errors with company’s imaging products and
        create optimal solutions to ensure highest quality and performance. Create test system
        databases for quality assurance documentation such as test strategy documents, test plans,
        test cases, defect reports, and test wrap-up reports. Analyze design improvements, upgrades,
        and additional features to be implemented for the medical devices and design additional
        testing plans and validation procedures. Launch the retesting phase and continually adjust
        the testing systems until the automation process is fully functional. Manage the engineering
        team and coordinate with operations, research, and development, and regulatory and
        operations team to ensure that all the company’s medical devices are thoroughly and
        appropriately tested during development and production. Make recommendations on how to grow
        the company’s medical platform and improve the quality of the company’s products, testing
        systems, and medical services. Stay abreast of the latest medical technological advances,
        industry trends, and changes in current quality and validation requirements and standards to
        ensure optimal quality, performance, and effective imaging product development.
      </>
    ),
    requirements: (
      <>
        This position requires a Master’s degree in Computer Engineering, Electrical Engineering, or
        a related field and two years of experience in the job offered or a related position. This
        may be substituted with a Bachelor’s’ degree in Computer Engineering, Electrical
        Engineering, or a related field and five years of experience in the job offered or a related
        position. The position requires skills and knowledge of V&amp;V (Verification and
        Validation), Power Supplies, Oscilloscope, National Instruments LabVIEW and Test Stand, SQL
        Server, C, C++, C# programming, and BOMs. It requires incidental travel - 1% of the time,
        not more than several days a few times a year.
        <br />
        Salary: $140,816.00 to 170,000.00 per year
        <br />
        40 hours/week.
        <br />
        Job Interview Site: Santa Clara, CA.
        <br />
        Email Resume to: Exo Imaging, Inc. at{" "}
        <a
          href="mailto:HR@exo.inc?subject = Career - Director of Software Applications Engineering:"
          alt="Submit your resume here"
        >
          HR@exo.inc
        </a>
      </>
    )
  },
  {
    pathname: "job-post3",
    buttonName: "GPU Engineer",
    header: "Career",
    title: "GPU Engineer",
    description: (
      <>
        Analyze the software and hardware infrastructure of the company’s proprietary ultrasound
        platform and determine how to optimize the Graphics Processing Unit (GPU). Analyze and
        define the features of the company’s current proprietary software systems and determine what
        changes are needed to ensure high quality acceleration within the GPU pipeline. Design
        blueprints and modules of image and signal processing pipelines and ensure that the systems’
        pipeline produces advanced images, processes, and imaging and signaling data into the GPU
        memory efficiently. Design and develop complex imaging modes and features such as advanced
        image processing, 3D visualization, and A-I assisted detection. Utilize platforms such as
        Metal2, CUDA, OpenGL, OpenCL, and Vulkan to develop software for graphic processors to
        improve image processing time and quality while still preserving the parallelism environment
        in the GPU. Create complex real-time signal processing algorithms and program them into
        graphic processors to ensure rapid transfer of data within the company’s proprietary
        systems. Maintain documentation of key project artifacts, features, application processes,
        system tools, and functionalities. Debug software applications to ensure quality and optimal
        performance and develop test plans and cases using an embedded coding language such as iOS
        (Swift), Android (Java/C++), or Python. Perform ongoing design and code reviews for changes
        or improvements in the system and ensure it meets the development, testing, and production
        standards of Class-II medical devices. Make changes to the GPU infrastructure based on new
        developments within the firmware and software when necessary. Maintain, update, and create
        standards for technical solutions and methods. Stay abreast of the latest technological
        advances and industry trends to ensure optimal performance and effective GPU development.
      </>
    ),
    requirements: (
      <>
        This position requires a Master’s degree in Computer Science, Computer Engineering,
        Electrical Engineering, or a related field and one year of experience in the job offered or
        a related position. This may be substituted with a Bachelor’s degree in Computer Science,
        Computer Engineering, Electrical Engineering, or a related field and five years of
        experience in the job offered or a related position. This position requires skills and
        knowledge in Python, C++, GPU, and CUDA.
        <br />
        Salary: $192,941.00 per year
        <br />
        40 hours/week.
        <br />
        Job Interview Site: Santa Clara, CA.
        <br />
        Email Resume to: Exo Imaging, Inc. at{" "}
        <a
          href="mailto:HR@exo.inc?subject = Career - Director of Software Applications Engineering:"
          alt="Submit your resume here"
        >
          HR@exo.inc
        </a>
      </>
    )
  },
  {
    pathname: "job-post4",
    buttonName: "Manager of Regulatory Affairs",
    header: "Career",
    title: "Manager of Regulatory Affairs",
    description: (
      <>
        Develop and implement regulatory strategies for the company’s medical imaging products and
        software. Oversee and manage the regulatory process throughout all stages of product
        lifecycle. Coordinate with medical regulatory and government agencies regarding product
        development details and development problems. Handle and support regulatory requests from
        regulatory agencies and prepare and submit product registrations and submissions to the FDA
        and other regulatory bodies. Develop and implement quality and regulatory strategies in
        adherence to the FDA’s Quality Systems Regulation. Advise executive management and all other
        departments about regulatory strategies, requirements, and FDA submissions and approvals.
        Ensure that the development of products adheres to the Quality Systems Regulations
        throughout every stage of the medical product lifecycle and that each project complies with
        the proposed pre-approved budgets. Provide leadership to ensure that all required validation
        is performed for process, tests, equipment, and facilities to meet medical industry or
        regulatory requirements. Act as a subject matter expert for Quality Assurance during
        regulatory FDA, ISO, and Notified Body audits. Lead the preparation for and management of
        regulatory inspections. Identify possible risks and issues that the company may encounter
        during the regulatory process and develop solutions. Stay abreast of the latest medical and
        technological advances, industry trends, and changes in current quality and regulatory
        requirements and standard.
      </>
    ),
    requirements: (
      <>
        The position requires a Master’s degree in Regulatory Science or a related field and two (2)
        years of experience in the job offered or a related position. This may be substituted with a
        Bachelor’s degree in Regulatory Science or a related field and five (5) years of experience
        in the job offered or a related position. The position requires experience and skills in
        Word, Excel, Visio, Microsoft 365, and familiarity with FDA&amp;s electronic submission
        tools. The position requires incidental travel - 1% of the time, not more than several days
        a few times a year.
        <br />
        Salary: $235,518.00 per year
        <br />
        40 hours/week.
        <br />
        Job Interview Site: Santa Clara, CA.
        <br />
        Email Resume to: Exo Imaging, Inc. at{" "}
        <a
          href="mailto:HR@exo.inc?subject = Career - Director of Software Applications Engineering:"
          alt="Submit your resume here"
        >
          HR@exo.inc
        </a>
      </>
    )
  }
]

export default {
  BREAKPOINTS,
  COLORS,
  GRADIENTS,
  CONTENT_PROPERTIES,
  CONTENT_TYPES,
  EVENTS,
  FLAGS,
  HERO_TYPES,
  IMAGE_DISPLAY,
  LOG,
  MEDIA_QUERIES,
  MISC,
  NEWS,
  PAGE_NAMES,
  SETTINGS,
  SUBMIT,
  SUBMIT_PROGRESS,
  THEMES,
  PAGE_TRACKER_KEYS,
  PAGE_TRACKER_VALUES,
  JOBS
}

export const FILTERS = [
  {
    adata: { content: "all resources" },
    ascope: "LISTS",
    buttonText: "The Latest",
    hash: "",
    key: 0,
    value: null
  },
  {
    adata: { content: "blogs" },
    ascope: "LISTS",
    buttonText: "Blogs",
    hash: "#blog",
    key: 1,
    value: "blog"
  },
  {
    adata: { content: "events" },
    ascope: "LISTS",
    buttonText: "Events",
    hash: "#event",
    key: 2,
    value: "event"
  },
  {
    adata: { content: "exo works" },
    ascope: "LISTS",
    buttonText: "Exo Works",
    hash: "#exo-works",
    key: 3,
    value: "exo works"
  },
  {
    adata: { content: "guides" },
    ascope: "LISTS",
    buttonText: "Guides",
    hash: "#guides",
    key: 4,
    value: "guides"
  },
  {
    adata: { content: "podcast" },
    ascope: "LISTS",
    buttonText: "Podcast",
    hash: "#podcast",
    key: 5,
    value: "podcast"
  },
  {
    adata: { content: "casestudy" },
    ascope: "LISTS",
    buttonText: "Case Study",
    hash: "#case-study",
    key: 5,
    value: "case study"
  }
]
